import { LocaleEnum } from '@systemeio/ui'

export const getCashOnDeliveryHelpPageLink = (locale?: LocaleEnum) => {
  switch (locale) {
    case LocaleEnum.DUTCH: {
      return 'https://help-nl.systeme.io/article/2284-hoe-je-de-contant-bij-levering-betalingsmethode-instelt-in-systeme-io'
    }
    case LocaleEnum.DEUTSCH: {
      return 'https://help-de.systeme.io/article/2307-so-richten-sie-die-zahlung-per-nachnahme-auf-systemeio-ein'
    }
    case LocaleEnum.FRENCH: {
      return 'https://aide.systeme.io/article/2220-comment-mettre-en-place-le-paiement-a-la-livraison-sur-systeme-io'
    }
    case LocaleEnum.JAPANESE: {
      return 'https://help-jp.systeme.io/article/2333-how-to-set-up-cash-on-delivery-payment-on-systeme-io'
    }
    case LocaleEnum.ARABIC: {
      return 'https://help-ar.systeme.io/article/2797-how-to-set-up-cash-on-delivery-payment-on-systemeio'
    }
    case LocaleEnum.PORTUGUESE: {
      return 'https://help-pt.systeme.io/article/2301-como-configurar-o-metodo-pagamento-na-entrega-na-systeme-io'
    }
    case LocaleEnum.SPANISH: {
      return 'https://help-es.systeme.io/article/2298-como-configurar-el-pago-contra-entrega-como-metodo-de-pago-en-systeme-io'
    }
    case LocaleEnum.ITALIAN: {
      return 'https://help-it.systeme.io/article/2246-come-impostare-il-contrassegno-come-metodo-di-pagamento-su-systeme-io'
    }
    default: {
      return 'https://help.systeme.io/article/2223-how-to-set-up-payment-on-delivery-on-systeme-io'
    }
  }
}
